// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Km-3","title":"Images90_title__1UVMa","images":"Images90_images__3IEBy"};